<template>
    <div
        v-if="show"
        :class="[
            show ? 'opacity-100' : 'opacity-0 -z-10 -top-full',
            'fixed flex top-0 left-0 items-center justify-center w-full h-screen',
            'bg-gray-300 bg-opacity-80 backdrop-blur-sm z-50 transition-all duration-100',
            'dark:bg-neutral-600 dark:bg-opacity-80'
        ]"
    >
        <div class="space-y-2">
            <span class="flex items-center text-chat-gray-dark text-sm uppercase dark:text-white">
                <svg
                    class="animate-spin -ml-1 mr-3 h-6 w-6 text-chat-primary"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                    />
                    <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                </svg>
                {{ text }}
            </span>
            <span class="flex w-full items-center text-center text-chat-gray-dark text-xs uppercase dark:text-white">{{ subtext }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingPage',
        props: {
            show: {
                type: Boolean,
                required: true,
                default: false,
            },
            text: {
                type: String,
                default: 'Carregando dados',
            },
            subtext: {
                type: String,
                default: '',
            },
        },
    }
</script>
